import type { SavedConstellation } from '../data/types';
import { Constellation } from './Constellation';
import styles from './Welcome.module.css';

interface WelcomeProps {
  saved: SavedConstellation | null;
  onBegin: () => void;
  onView: () => void;
}

export function Welcome({ saved, onBegin, onView }: WelcomeProps) {
  return (
    <section className={styles.welcome}>
      <h1 className={styles.heading}>the archetype mirror</h1>
      <p className={styles.subtitle}>a self-portrait of your submission, drawn in stars</p>

      <p className={styles.body}>
        twenty-four reflective prompts. you rate each from <em>not me at all</em> to{' '}
        <em>deeply me</em>. at the end, a six-point constellation appears — your
        unique balance across six archetypes of submission. nothing here is a
        verdict; it is a starting point.
      </p>

      <div className={styles.actions}>
        <button type="button" className={styles.begin} onClick={onBegin}>
          {saved ? 'take it again' : 'begin'}
        </button>
        {saved && (
          <button type="button" className={styles.viewBtn} onClick={onView}>
            see my saved constellation
          </button>
        )}
      </div>

      {saved && (
        <div className={styles.savedPreview}>
          <p className={styles.savedLabel}>your last reading</p>
          <p className={styles.savedName}>{saved.name}</p>
          <div className={styles.savedConstellation}>
            <Constellation scores={saved.scores} animated={false} />
          </div>
        </div>
      )}
    </section>
  );
}
